import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AprovacaoRoutingModule } from './aprovacao-routing.module';
import { AprovacaoComponent } from './aprovacao.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AprovacaoModalFormComponent } from './aprovacao-modal-form/aprovacao-modal-form.component';

@NgModule({
  declarations: [AprovacaoComponent, AprovacaoModalFormComponent],
  imports: [CommonModule, AprovacaoRoutingModule, SharedModule]
})
export class AprovacaoModule {}
